module.exports = __webpack_public_path__ + "img/3ca719a.jpg";